module.exports = __webpack_public_path__ + "img/sld_mfm_invs_5_dark.ea526712.svg";